import React, { useState } from "react";
import { Icon } from "semantic-ui-react";
import { ListBuilder, Table } from "@redriver/cinnamon";
import { Targets, Actions } from "constants/Permissions";
import { PermissionCheck } from "components/auth";
import { TablePanel, HeaderBar } from "components/containers";
import AddDocumentType from "./AddDocumentType";
import EditDocumentType from "./EditDocumentType";
import DeleteDocumentType from "./DeleteDocumentType";
import DocumentTypeActions from "./DocumentTypeActions";
import { getDocumentTypes } from "./actions";

const ListDocumentTypes = () => {
  const [editing, setEditing] = useState(null);
  const [deleting, setDeleting] = useState(null);

  return (
    <ListBuilder
      withTable
      loadAction={getDocumentTypes}
      renderList={(tableProps, state, events) => (
        <React.Fragment>
          <TablePanel
            customHeader={
              <HeaderBar
                name="Document Types"
                rightContent={
                  <AddDocumentType
                    content="Add Document Type"
                    onAdded={events.onRefresh}
                  />
                }
              />
            }
            {...tableProps}
            dataKey="id"
            emptyMessage="No document types found"
            selectable
          >
            <Table.Column field="name" title="Name" width="70%" />
            <Table.Column
              title="System Defined"
              width="10%"
              render={(documentType) =>
                documentType.isSystem ? (
                  <Icon name="check" color="grey" />
                ) : (
                  <Icon name="times" color="grey" />
                )
              }
            />
            <Table.Column
              title="App can Upload Photos"
              width="10%"
              render={(documentType) =>
                documentType.allowPhotoUploadsFromApp ? (
                  <Icon name="check" color="grey" />
                ) : (
                  <Icon name="times" color="grey" />
                )
              }
            />
            <PermissionCheck
              target={Targets.DocumentType}
              action={[Actions.Edit, Actions.Delete]}
              any
            >
              <Table.Column
                hoverable
                width="10%"
                align="right"
                render={(documentType) => (
                  <DocumentTypeActions
                    documentType={documentType}
                    onEdit={setEditing}
                    onDelete={setDeleting}
                  />
                )}
              />
            </PermissionCheck>
          </TablePanel>
          {editing && (
            <EditDocumentType
              documentType={editing}
              onCancel={() => setEditing(null)}
              onUpdated={() => {
                setEditing(null);
                events.onRefresh();
              }}
            />
          )}
          {deleting && (
            <DeleteDocumentType
              documentType={deleting}
              onCancel={() => setDeleting(null)}
              onDeleted={() => {
                setDeleting(null);
                events.onRefresh();
              }}
            />
          )}
        </React.Fragment>
      )}
    />
  );
};

export default ListDocumentTypes;
